import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'ContactUsForm';

/**
 * Errors related to the Contact page
 */
export const Errors = createErrors<Page, Component>('Contact')({
    ContactUsForm: {
        SubmitFailed: {
            severity: 'MEDIUM',
            message: 'Failed to submit contact us form',
        },
    },
});
